import { render, staticRenderFns } from "./ManageBetslipV2.vue?vue&type=template&id=79da71a4&scoped=true&"
import script from "./ManageBetslipV2.vue?vue&type=script&lang=js&"
export * from "./ManageBetslipV2.vue?vue&type=script&lang=js&"
import style0 from "./ManageBetslipV2.vue?vue&type=style&index=0&id=79da71a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da71a4",
  null
  
)

export default component.exports